import {Controller} from "stimulus"

export default class extends Controller {
  static targets = ["drawer"]

  show() {
    this.drawerTarget.show()
  }
}
